/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Features_Desk_FeedInputs */

const en_features_desk_feed = /** @type {(inputs: Features_Desk_FeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live: ${i?.name}`)
};

const pl_features_desk_feed = /** @type {(inputs: Features_Desk_FeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Na żywo: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Live: {name}" |
*
* @param {Features_Desk_FeedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_feed = /** @type {((inputs: Features_Desk_FeedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_FeedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_feed(inputs)
	return en_features_desk_feed(inputs)
});